// Setup › Memory at `/c/{slug}/setup/memory` (RECALL-ADMIN-MEMORY; managers, the `memory`
// add-on): Review, Browse, Spaces, Rules, Health. While the add-on is off a direct URL says
// "not enabled".
import { createRoute } from "@tanstack/react-router";
import { MemoryAdminScreen } from "../features/memory/memory-admin";
import { useCompany, useFeature } from "../features/use-feature";
import { NotEnabledPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

export const setupMemoryRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "memory",
  component: function Memory() {
    const { api } = setupMemoryRoute.useRouteContext();
    const company = useCompany();
    const memory = useFeature("memory");
    if (!memory.enabled)
      return (
        <NotEnabledPage
          what="Memory"
          feature="memory"
          companyName={company.name}
          slug={company.slug}
        />
      );
    return <MemoryAdminScreen api={api} company={company} />;
  },
});
